import { useEffect, useState } from 'react';
import '../styles/familyOffice.css';
import { useNavigate } from 'react-router-dom';
import Apis from '../services/apis';

export default function Orgs({ onSelect }) {
  const [clients, setClients] = useState([]);
  const navigate = useNavigate();
  const apis = new Apis();
  const [load, setLoad] = useState(true);

  useEffect(() => {
    getOrgs()
  }, []);

    const getOrgs = () => {
      apis.getTerminalOrgs()
      .then((response) => {
          let data = response.data.organizations;
          setClients(data)
          setLoad(false)
      })
      .catch((error) => {
          if (error.response && error.response.status === 404) {
              setLoad(false)
              alert("Error occurred while fetching categories "+ error.response.data.message);
          } else {
              // Handle other errors
              console.error("Error:", error);
              alert("Error occurred while fetching asset data");
          }
      });
    }

    if (load) {
      return (
        <div style={{
          height: '80vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div
            style={{
              width: '80px',
              height: '80px',
              border: '10px solid rgba(255,255,255,0.2)',
              borderTop: '10px solid #F4A31E',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}
          />
        </div>
      );
    }
    
    else{
      return (
        <div className="page" style={{padding:'20px',background:'#0A0A0A',height:'100%'}}>
          <h2>Terminal Organisations</h2>
          <div className="client-list" style={{marginTop:'30px'}}>
            {clients.map(c => (
              <div key={c.id} className="client-card" 
              onClick={() => {
                // onSelect(c.id)
                localStorage.setItem("selected_org_id",c.id)
                navigate(`/family-office`);
              }}>
                <div className="client-row">
                  <div className="client-avatar">
                    {c.name?.slice(0, 1).toUpperCase()}{c.name.split(" ")?.[1]?.slice(0, 1).toUpperCase()}
                  </div>
    
                  <div className="client-info" style={{paddingLeft:'10px'}}>
                    <strong className="client-name">{c.name.toUpperCase()} ({c.id})</strong>
                    {/* <p className="client-contact">
                      Primary Contact: {c.contact}
                    </p> */}
                    {/* <p className="client-contact">
                    {c.holdings} holdings
                    </p> */}
                  </div>
                </div>
                {/* <div className="right" style={{display:'flex',flexDirection:'column',alignItems:'flex-end',justifyContent:'center',fontSize:'12px'}}>
                  <span>${c.aum}M</span>
                  <small style={{marginLeft:'10px'}}>{c.holdings }holdings</small>
                </div> */}
              </div>
            ))}
          </div>
        </div>
      );
    }

}